import React from 'react';
import {ThemeProvider, type DefaultTheme} from 'styled-components';
import {ForecastTheme, tokensForThemeProvider} from '@forecast-it/design-system';

// Ticketing renders inside Forecast's ForecastThemeProvider in the real
// app (see ticketing-embed.tsx), so the design-system base tokens (theme.spacing,
// theme.size, theme.sys, …) that DS primitives like Modal/FocusRing/Checkbox read
// are normally supplied by that parent. We therefore MERGE — don't replace —
// using the function form, keeping whatever the parent provided.
//
// In isolated unit tests there is no ForecastThemeProvider above us, so we fold the
// DS Sky base tokens in as a FALLBACK underneath the parent: the parent (production)
// still wins for every key it sets (incl. its Sky/Sage choice), while tests — which
// have no parent — get a real DS base so primitives don't crash on undefined
// theme.spacing/size. `tokensForThemeProvider` is a direct design-system export
// (the same package ticketing components already import primitives from); in CI it
// carries the real spacing/size tokens, and the jest mock keeps it import-safe.
const dsBase = (tokensForThemeProvider && tokensForThemeProvider[ForecastTheme.Sky]) || {};

export const TicketingThemeProvider: React.FC<{children: React.ReactNode}> = ({children}) => (
	<ThemeProvider theme={(parent: DefaultTheme) => ({...dsBase, ...parent})}>{children}</ThemeProvider>
);
